import { subToBroadcastChannel } from  '../../channels/broadcast_channel'
import axios from '../../shared/axiosConfig';
import * as AppActions from './App';
import { push } from 'connected-react-router'
import AgoraRTC from 'agora-rtc-sdk'

export const BroadcastActions = {
  SET_ATTRIBUTE: "BROADCAST_SET_ATTRIBUTE",
  ADD_REMOTE_STREAM: "BROADCAST_ADD_REMOTE_STREAM",
  REMOVE_REMOTE_STREAM: "BROADCAST_REMOVE_REMOTE_STREAM",
  RESET_STATE: "BROADCAST_RESET_STATE",
  ADD_MESSAGE: "BROADCAST_ADD_MESSAGE",
};

export const BroadcastResetState = () => {
  return {
    type: BroadcastActions.RESET_STATE
  }
}

/**
 * @param {*} value
 */
export const addRemoteStream = (id, value) => {
  return {
    type: BroadcastActions.ADD_REMOTE_STREAM,
    id,
    value
  };
};

export const removeRemoteStream = (id) => {
  return {
    type: BroadcastActions.REMOVE_REMOTE_STREAM,
    id
  };
};

export const addMessage = (storageKey, message) => {
  return {
      type: BroadcastActions.ADD_MESSAGE,
      key: 'all',
      value: { storageKey,  message }
  }
};

/**
 * @param {String} key
 * @param {*} value
 */
export const setBroadcastAttribute = (key, value) => {
  return {
    type: BroadcastActions.SET_ATTRIBUTE,
    key,
    value
  };
};

export const getBroadcastToken = (eventId, companyId) => async (dispatch)  => {
  dispatch( AppActions.setLoading(true) );
  await axios.post(`/api/events/${eventId}/companies/${companyId}/broadcast_token`)
    .then(async (response) => {
      console.log("Got token", response);
      dispatch( AppActions.setLoading(false) );
      dispatch( setBroadcastAttribute('options', response.data ) );
    })
    .catch((error) => {
      console.log("Error getting token", error);
      dispatch( AppActions.setLoading(false) );
      // TODO: put app-wide error here
    })
}

export const releaseRTC = () => async (dispatch, getState) => {
  let client = getState().broadcast.client;
  console.log("Releasing RTC client...", client);
  client.leave(function() {
    console.log("client leaves channel");
    dispatch(setBroadcastAttribute('client', null));
    dispatch(BroadcastResetState());
  }, function(err) {
    console.log("client leave failed ", err);
  });
}

export const listenToBroadcast = () => async (dispatch, getState) => {
  console.log("[DEBUG]Listen to broadcast");
  let options = getState().broadcast.options;
  let params = getState().broadcast.params;
  let { eventId, companyId } = getState().company;
  if( ! options.token ) {
    console.log("[DEBUG]Request broadcast token");
    await dispatch( getBroadcastToken(eventId, companyId) );
    options = getState().broadcast.options;
  }

  console.log("[DEBUG]Creating AgoraRTC client");
  // create a client
  let client = AgoraRTC.createClient({mode: "live", codec: "vp8"});
  console.log("[DEBUG]Successfully created AgoraRTC client");
  dispatch(setBroadcastAttribute('client', client));
  // Initialize the client
  client.init(options.appID, function () {
    console.log("RTC client - init success");
    client.setClientRole("audience");
    // join channel
    client.join( options.token,
      options.channel,
      options.uid,
      function (uid) {
        console.log("### Joined channel: " + options.channel + " success, uid: " + uid);
        dispatch( setBroadcastAttribute('params', {uid}) );
        //
        client.on('stream-subscribed', (evt) => {
          var remoteStream = evt.stream;
          let id = remoteStream.getId();
          console.log('stream-subscribed remote-uid: ', id);
          client.setRemoteVideoStreamType(remoteStream, 0);
          dispatch( addRemoteStream(id, remoteStream) );
        })
        // subscribe for remote streams
        client.on("stream-added", function (evt) {
          let remoteStream = evt.stream;
          let id = remoteStream.getId();
          console.log('stream-added remote-uid: ', id);
          client.subscribe(remoteStream, function (err) {
            console.log("stream subscribe failed", err);
          });
        });

        client.on("stream-removed", function (evt) {
          var remoteStream = evt.stream;
          var id = remoteStream.getId();
          // Stop playing the remote stream.
          // remoteStream.stop("remote_video_" + id);
          // Remove the view of the remote stream.
          // removeView(id);
          console.log('stream-removed remote-uid: ', id);
          dispatch( removeRemoteStream(id) );
        });
        //
      }, function(err) {
        console.error("client join failed", err); // TODO: handle error
      });
  }, (err) => {
    console.error(err); // TODO: handle error
  });
}

export const sendMessage = (msg) => (dispatch, getState) => {
  console.log("New message", msg);
  let channel = getState().broadcast.channel;
  channel.sendMessage(msg);
}

export const subToBroadcast = () => async (dispatch, getState) => {
  let alreadySubscribed = getState().broadcast.sub;
  let props = getState().company;

  const handleData = (data) => {
    console.log("Incoming broadcast data", data);
    let storageKey = `${props.eventId}:${props.companyId}`
    if( data.type == 'message' ) {
      let { uuid } = getState().profile.data;
      console.log("Current peer uuid", uuid);
      if( data.payload.peer == uuid ) { // only display own questions
        dispatch( addMessage( storageKey, data.payload) );
      }
    }
  }

  const handleChannel = (channel) => {
    dispatch( setBroadcastAttribute('channel', channel) );
  }

  if( ! alreadySubscribed ) {
    await subToBroadcastChannel(props, handleData, handleChannel);
    dispatch(setBroadcastAttribute('sub', true));
  }
}

export const leaveBroadcast = () => (dispatch, getState) => {
  let alreadySubscribed = getState().broadcast.sub;
  let channel = getState().broadcast.channel;
  if( alreadySubscribed ) {
    channel.leave();
    console.log("Left broadcast");
  }
  dispatch(setBroadcastAttribute('sub', false));
  dispatch(setBroadcastAttribute('channel', null));
}
